<template>
  <v-autocomplete
    @input="setDealer"
    :value="value"
    ref="dealer_id"
    :items="dealers"
    item-text="name"
    item-value="id"
    :label="label || 'Select a Dealer'"
    :error-messages="errorMessages"
    :disable="disabled"
    return-object
    required
    :rules="rules"
    outlined
    prepend-inner-icon="mdi-car-side"
    :filter="dealerSearchFilter"
    :multiple="multiple"
  >
  </v-autocomplete>
</template>

<script>
import { DealerApi } from '@/services'

export default {
  name: 'dealer-select-standalone',
  props: {
    value: {
      type: [Number, String, Array],
      required: false,
      default: null
    },
    errorMessages: {
      type: Array
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    label: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      dealer: {},
      dealers: []
    }
  },
  computed: {
  },
  mounted: function () {
    return DealerApi.fetchDealers()
      .then(resp => {
        this.dealers = resp.data
      })
      .catch(error => {
        this.$logger.error('Error loading dealer(s) into dealer-select-standalone', error.message)
        this.$flash({
          showClose: true,
          message: 'Error Loading Dealer(s). Reload to try again - DealerSelectStandalone',
          type: 'error'
        })
      })
  },

  methods: {
    setDealer: function (selectedDealer) {
      this.$emit('input', selectedDealer ? selectedDealer.id : null)
    },
    dealerSearchFilter (item, queryText, itemText) {
      const dealerName = item.name.toLowerCase()
      const dmsKey = item.dms_key
      const searchText = queryText.toLowerCase()

      return dealerName.indexOf(searchText) > -1 || dmsKey.indexOf(searchText) > -1
    }
  }
}
</script>
